// classLink.js — DEPRECATED alias layer (Sep 2026). The ONE class link is lib/teacherLink.js (we_teacher_link_v1) and
// the ONE evidence path is lib/classAssignments.js → /api/school/evidence. Kept only so older call sites keep working;
// nothing is stored under `mwq_class_link` any more.
import { getTeacherLink, saveTeacherLink, clearTeacherLink } from "@/lib/teacherLink";
import { fetchClassAssignments, recordSchoolEvidence } from "@/lib/classAssignments";

export function getClassLink() {
  const l = getTeacherLink();
  return l ? { class_id: l.class_id, child_id: l.member_id, display_name: l.member_alias, join_code: l.join_code, class_name: l.class_name } : null;
}
export function setClassLink(link) {
  saveTeacherLink({ class_id: link.class_id, member_id: link.child_id, member_alias: link.display_name, join_code: link.join_code, class_name: link.class_name, device_id: link.device_id });
}
export function clearClassLink() { clearTeacherLink(); }

/** Progress on a quest/trial → evidence ONLY when it maps to one of the class's real assignments (objective). */
export async function reportClassProgress({ assignment_id, status, stars = 0 }) {
  if (!getTeacherLink()?.member_id || !assignment_id) return;
  try {
    const items = await fetchClassAssignments();
    const a = items.find((x) => x.id === assignment_id || x.code === assignment_id);
    if (!a) return;
    await recordSchoolEvidence({ code: a.code, sourceType: status === "mastered" ? "CHECK" : "LESSON", assignmentId: a.id,
      result: { status, stars, ...(status === "mastered" ? { pct: 100 } : {}) } });
  } catch { /* silent — offline tolerant */ }
}
